import React from 'react';
import {formatAverageRating} from '../../../../utils';

interface SkillItemProps {
  name: string;
  rating?: number | null;
  icon?: React.ElementType | null | string;
  className?: string;
  appreciatedByText?: string | null;
}

export function SkillItem({
  name,
  rating,
  icon,
  className = '',
  appreciatedByText,
}: SkillItemProps) {
  return (
    <div
      className={`bg-gray-100 rounded-lg p-3 flex flex-col gap-2 break-inside-avoid ${className}`}>
      <div className="flex justify-between items-center gap-2">
        <div className="flex items-center gap-1">
          {icon &&
            typeof icon === 'function' &&
            React.createElement(icon, {className: 'w-3 h-3 text-primary'})}
          <span className="text-md font-bold leading-tight text-gray-800">
            {name}
          </span>
        </div>
        <span className="text-md font-extrabold leading-tight text-primary">
          {formatAverageRating(rating)}/10
        </span>
      </div>
      <div className="w-full h-1 rounded-full bg-primary/10">
        <div
          className="h-full rounded-full bg-gradient-to-r from-primary to-orange-500"
          style={{width: `${(rating || 0) * 10}%`}}></div>
      </div>
      {appreciatedByText ? (
        <p className="text-xs italic text-gray-400 leading-tight mt-1">
          {appreciatedByText}
        </p>
      ) : null}
    </div>
  );
}
